const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const PaymentCommand: any = {
    AddOrUpdateInstallments: Backofficebff + '/fix/v1/payment/AddOrUpdateInstallments',
    DeleteInstallments: Backofficebff + '/fix/v1/payment/DeleteInstallments',
    UpdateCustomerPaymentMethodAvailabilityStatus:
        Backofficebff + '/v1/payment/updatecustomerpaymentmethodavailabilitystatus',
    RemoveCustomerPaymentMethodBlock: Backofficebff + '/v1/payment/removecustomerpaymentmethodblock',
    GetCustomerPaymentMethodAvailabilityStatusHistory:
        Backofficebff + '/v1/payment/getcustomerpaymentmethodavailabilitystatushistory',
    GetCustomerPaymentRequestList: Backofficebff + '/v1/payment/getcustomerpaymentrequestlist',
    GetCardListByCustomerId: Backofficebff + '/v1/payment/getCardListByCustomerId',
    GetPaymentsWithOrderIdList: Backofficebff + '/v1/payment/get-payments-with-orderId-list',
    CheckDigitalCardPayment: Backofficebff + '/v1/payment/check-digital-card-payment',
    GetBankAccountListByCustomer: Backofficebff + '/v1/payment/getbankaccountlistbycustomer',
    InsertCustomerBankAccount: Backofficebff + '/v1/payment/insertcustomerbankaccount',
    UpdateCustomerBankAccount: Backofficebff + '/v1/payment/updatecustomerbankaccount',
    SendPaymentSms: Backofficebff + '/v1/payment/send-payment-sms',
    SendEmailForDigitalCard: Backofficebff + '/v1/payment/send-digital-card-email',
    DeleteCustomerBankAccount: Backofficebff + '/v1/payment/deletecustomerbankaccount',
    GetBankAccountByCustomerBankAccountId: Backofficebff + '/v1/payment/get-bank-account-by-customer-bank-accountId',
    PaymentMethodList: Backofficebff + '/v1/payment/payment-method-list',
    ProcessMobileExpressOrders: Backofficebff + '/v1/payment/process-mobilexpress-orders',
};
